// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a679b4db","455":"2ade9aa4","977":"d102c3ef"}[chunkId] + ".chunk.js";
};